import React from "react";
import { connect } from "react-redux";
import {
    createPage,
    fetchPage,
    fetchPages,
    savePage,
} from "../../reducers/pages/actions";
import { Form, getURLParam, FORM_END_PROCESSING } from "../../lib";
import { i18n, navigate, eventEmitter } from "../../services";
import { Constraints, Fields, Editing } from "./types";
import { Map } from "immutable";
import { AppState } from "../../store";

interface OwnProps {
    doc_id: number;
    page_id: number;
    editing: Editing;
}
type PagesList = ReturnType<typeof Map>;
const mapState = (state: AppState, { doc_id, page_id }: OwnProps) => {
    const list = state.pages as PagesList;
    //@ts-ignore
    const page = list.get(page_id);
    const pages = list.filter((p: any) => p.get("doc_id") === doc_id);

    return { page, pages };
};
const mapDispatch = { fetchPage, fetchPages, createPage, savePage };

type StateProps = ReturnType<typeof mapState>;
type DispatchProps = typeof mapDispatch;

type Props = StateProps & DispatchProps & OwnProps;

class PageForm extends React.Component<Props> {
    private order = ["name", "parent_id"];

    private fields: Fields = {
        name: {
            type: "text",
        },
        parent_id: {
            type: "select",
            value: parseInt(getURLParam("parent_id")!) || 0,
            values: [0],
            labels: [i18n.get("form.selectEmptyLabel")],
        },
    };

    private constraints: Constraints = {
        name: {
            presence: { message: "nameRequired" },
            length: {
                minimum: 3,
                message: "nameMinChars",
            },
        },
    };

    componentDidMount() {
        const { doc_id } = this.props;
        this.props.fetchPages({ doc_id });

        if (this.props.editing === "Edit") {
            this.order = ["name", "parent_id", "status"];
            this.fields.status = {
                type: "select",
                value: "PUBLISHED",
                values: ["DRAFT", "PUBLISHED"],
            };
        }

        eventEmitter.on(FORM_END_PROCESSING, () =>
            this.props.fetchPages({ doc_id })
        );
    }

    componentWillReceiveProps(nextProps: Props) {
        this.fillPages(nextProps.pages as any);
    }

    fillPages = (pages: PagesList) => {
        const values = [0];
        const indents = [0];
        const hasChildren = [false];
        const labels = [i18n.get("form.selectEmptyLabel")];

        pages.forEach((p: any) => {
            hasChildren.push(p.get("_hasChildren"));
            indents.push(parseInt(p.get("_indent")));
            values.push(p.get("id"));
            labels.push(p.get("name"));
        });

        this.fields.parent_id.hasChildren = hasChildren;
        this.fields.parent_id.indents = indents;
        this.fields.parent_id.values = values;
        this.fields.parent_id.labels = labels;
        this.fields = {
            ...this.fields,
        };
    };

    onSubmit = (values: Record<string, any>) => {
        const { doc_id, page_id, editing } = this.props;

        if (editing === "Edit") {
            this.props.savePage({
                doc_id,
                page_id,
                data: values,
                redirect: false,
            });
        } else {
            this.props.createPage({
                doc_id,
                data: {
                    ...values,
                    status: "PUBLISHED",
                },
                redirect: getURLParam("redirect") || false,
            });
        }
    };

    onCancel = () => navigate.to(`/app/pages/${this.props.doc_id}`);

    render() {
        return (
            <Form
                id="page"
                heading="title"
                updateProp="page"
                page={this.props.page}
                order={this.order}
                fields={this.fields}
                constraints={this.constraints}
                focusOnFirst={true}
                editing={this.props.editing}
                onSubmit={this.onSubmit}
                onAlternate={this.onCancel}
            />
        );
    }
}

export default connect(mapState, mapDispatch)(PageForm);
